"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const abstract_block_component_1 = require("../abstract-block/abstract-block.component");
let BuildingBlockPageBreakComponent = 
// eslint-disable-next-line max-len
class BuildingBlockPageBreakComponent extends abstract_block_component_1.AbstractBuildingBlock {
};
BuildingBlockPageBreakComponent = __decorate([
    (0, core_1.Component)({
        selector: 'block-page-break',
        templateUrl: require('./block-page-break.component.html'),
    })
    // eslint-disable-next-line max-len
], BuildingBlockPageBreakComponent);
exports.default = BuildingBlockPageBreakComponent;
